import { useQueryClient } from 'react-query';
import { useAccountingUpdateSocketEvent } from 'hooks/useAccountingUpdateFromSocket';

const useRevenueSocket = (): void => {
  const queryCache = useQueryClient();

  useAccountingUpdateSocketEvent({
    callback: () => {
      queryCache.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey;
          return Array.isArray(key) && key.includes('revenue-accounting');
        },
      });
    },
  });
};

export default useRevenueSocket;
